// LAP-550 — Card Forex : header + grille de devises (HTML rendu via dangerouslySetInnerHTML)
import { Box, Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import CardHeader from '../../_shared/CardHeader'

export default function CurrencyExchange({ result = [] }) {
  const { t } = useTranslation('layout')
  return (
    <Box display="flex" flexDirection="column" height="100%">
      <CardHeader
        icon="/images/Forex.png"
        title={t('investments.markeet.forex.title')}
        subtitle={t('investments.markeet.forex.subtitle')}
      />

      <Box
        mt={2}
        height="100%"
        sx={{
          overflow: 'auto',
          '.fbox': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            backgroundColor: 'rgba(255,255,255,0.03)',
            borderRadius: 1.25,
            border: '1px solid rgba(255,255,255,0.05)',
            padding: 1,
          },
          '.fimg': { mr: 0.75, width: 24, height: 24, borderRadius: '50%', overflow: 'hidden' },
          '.fimg img': { height: '100%', width: '100%', objectFit: 'cover' },
          '.fbcenter': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            color: 'rgba(255,255,255,0.85)',
            fontWeight: 600,
            fontSize: 11,
            letterSpacing: 0.3,
          },
          '.cbox': { fontSize: 11, textAlign: 'center', color: 'rgba(255,255,255,0.85)', lineHeight: 1.45 },
          '.cuy': { fontSize: 9, color: 'rgba(255,255,255,0.5)' },
          '.red': { color: '#ef4444', fontWeight: 600 },
          '.green': { color: '#22c55e', fontWeight: 600 },
        }}
      >
        <Grid container spacing={1}>
          {result.map((item, index) => (
            <Grid item xs={2} dangerouslySetInnerHTML={{ __html: item.html }} key={index} />
          ))}
        </Grid>
      </Box>
    </Box>
  )
}
